import React from "react";
import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { ReactComponent as ImageIcon } from "../../../../assets/appearencePage/image.svg";
import { ReactComponent as ImageIconDark } from "../../../../assets/appearencePage/image-dark.svg";
import { Link } from "react-router-dom";
import { FavIconAcc } from "../../largeScreen/appearance/accordions";
import useLocales from "../../../../hooks/useLocales";
import useSettings from "../../../../hooks/useSettings";
import { useSelector } from "react-redux";

const FavIcon = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();

  return (
    <div className="px-6">
      <div className="md:hidden mt-10 mb-10 ">
        <Link className="flex items-center gap-3" to={"/dashboard/appearance"}>
          <div className=" flex items-center justify-center">
            {darkMode ? (
              <LeftArrowDark
                className={`h-[20px] w-[20px] ${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            ) : (
              <LeftArrow
                className={`h-[20px] w-[20px] ${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            )}
          </div>
          <h6 className="w-full text-body_copy2 dark:text-color_v1_dark">
            {/* Favicon */}
            {translate("appearance.favicon")}
          </h6>
        </Link>
      </div>

      <div
        className={`dark:border-color_dark bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] border border-light_bg_v2 p-6 py-[25px] mb-10`}
      >
        <div className="flex gap-2 justify-between items-center cursor-pointer">
          <div>
            {darkMode ? (
              <ImageIconDark width={20} height={20} />
            ) : (
              <ImageIcon width={20} height={20} />
            )}
          </div>

          <h1 className="text-small2_b text-dark_bg_v1 w-full dark:text-color_v1_dark">
            {/* FAVICON */}
            {translate("appearance.favicon_cap")}
          </h1>
        </div>

        <FavIconAcc />
      </div>
    </div>
  );
};

export default FavIcon;
